"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevenuePoolSchema = void 0;
const zod_1 = require("zod");
exports.RevenuePoolSchema = zod_1.z.object({
    _id: zod_1.z.string().optional(),
    partnerId: zod_1.z.string().optional(),
    title: zod_1.z.string().min(1),
    fileUrl: zod_1.z.string().url().optional().nullable(),
});
//# sourceMappingURL=revenue-pool.js.map